import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const AddIcon: React.FC<IconProps> = props => (
  <Icon fill="currentColor" {...props}>
    <path d="M11 19V13H5V11H11V5H13V11H19V13H13V19H11Z" />
  </Icon>
)
